import { render, staticRenderFns } from "./KoioteImageSwitchCanvas.vue?vue&type=template&id=6a49aa8a&lang=es"
import script from "./KoioteImageSwitchCanvas.vue?vue&type=script&lang=js"
export * from "./KoioteImageSwitchCanvas.vue?vue&type=script&lang=js"
import style0 from "./KoioteImageSwitchCanvas.vue?vue&type=style&index=0&id=6a49aa8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports